// Pure helpers for the "Contenido" folder tree. Paths use "/" between segments; "" is the root.
export const ROOT_LABEL = 'Contenido';
export const MAX_FOLDER_DEPTH = 5;
export const MAX_FOLDER_NAME_LENGTH = 100;

export const joinPath = (parent, name) => (parent ? `${parent}/${name}` : name);

const splitPath = (path) => (path ? path.split('/') : []);

export const getBreadcrumbs = (path) => {
  const crumbs = [{ name: ROOT_LABEL, path: '' }];
  let acc = '';
  splitPath(path).forEach((segment) => {
    acc = joinPath(acc, segment);
    crumbs.push({ name: segment, path: acc });
  });
  return crumbs;
};

const lastSegment = (path) => path.slice(path.lastIndexOf('/') + 1);

export const getChildFolders = (folders, currentPath) =>
  folders
    .filter((f) => {
      const prefix = currentPath ? `${currentPath}/` : '';
      return f.path.startsWith(prefix) && !f.path.slice(prefix.length).includes('/');
    })
    .sort((a, b) => lastSegment(a.path).localeCompare(lastSegment(b.path)));

export const getFilesInPath = (files, currentPath) =>
  files.filter((f) => (f.folderPath || '') === currentPath);

// Destination list for the "Mover" selector: root first, then every folder by path.
export const getFolderOptions = (folders) => [
  { path: '', label: ROOT_LABEL },
  ...[...folders]
    .sort((a, b) => a.path.localeCompare(b.path))
    .map((f) => ({ path: f.path, label: [ROOT_LABEL, ...splitPath(f.path)].join(' / ') })),
];

// Mirrors the backend rules so the user gets feedback before the request.
export const validateFolderName = (rawName, parentPath) => {
  const name = (rawName || '').trim();
  if (!name) return { ok: false, error: 'El nombre de la carpeta no puede estar vacío.' };
  if (name === '.' || name === '..' || /[/\\]/.test(name) || /[\u0000-\u001f\u007f]/.test(name)) {
    return { ok: false, error: 'El nombre de la carpeta contiene caracteres inválidos.' };
  }
  if (name.length > MAX_FOLDER_NAME_LENGTH) {
    return { ok: false, error: `El nombre no puede superar ${MAX_FOLDER_NAME_LENGTH} caracteres.` };
  }
  if (splitPath(parentPath).length >= MAX_FOLDER_DEPTH) {
    return { ok: false, error: `No se admiten más de ${MAX_FOLDER_DEPTH} niveles de carpetas.` };
  }
  return { ok: true, name };
};
